var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShapeLeftTop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 418,
    height: 242,
    viewBox: "0 0 418 242",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M242.876 46.3948C342.513 65.4121 338.858 -18.223 327.899 -53.3659L-82.4797 -60.1676V151.824C-13.632 235.087 59.5779 145.082 80.6797 78.3314C105.909 21.3693 192.996 33.5469 242.876 46.3948Z",
    fill: "#014641"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M284.317 69.134C386.143 123.133 409.474 36.7604 409.061 -2.80974L-33.6781 -152.439L-102.861 63.2703C-55.3846 171.936 53.3673 105.81 98.0308 45.2274C143.976 -3.96023 234.426 38.715 284.317 69.134Z",
    stroke: "#32AAA1",
    strokeWidth: 3
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShapeLeftTop);
export default __webpack_public_path__ + "static/media/ShapeLeftTop.f24e38346e2a666699da500e17193aa9.svg";
export { ForwardRef as ReactComponent };